// @Flow
import Vue from 'vue'
import type { CardSummary } from '../../../types/card-summary'
import type { CardDetails } from '../../../types/card-details'
import type { B2bClientInterface } from '../../../services/b2b/b2b-client-interface'
import * as mutationTypes from './mutation-types'
import {DEFAULT_CURRENT_PAGE_NUMBER} from './index'

export default {
  loadCompanyCards: async ({ commit, state }: { commit: (string, Array<CardSummary>) => void }): Promise<void> => {
    const client: B2bClientInterface = Vue.prototype.$container.b2bClient
    try {
      const result = await client.getCompanyCards(
        state.companyCardsCurrentPageNumber,
        state.companyCardsPageSize,
        state.filter,
        state.orderBy,
        state.orderDirection
      )
      commit(mutationTypes.SET_COMPANY_CARDS_FOR_CURRENT_FILTER, result.items)
      commit(mutationTypes.SET_TOTAL_NO_COMPANY_CARDS_FOR_CURRENT_FILTER, result.count)
    } catch (e) {
      commit(mutationTypes.SET_COMPANY_CARDS_FOR_CURRENT_FILTER, [])
      throw e
    }
  },
  loadCardDetails: async ({ commit }: { commit: (string, CardDetails) => void }, cardId: number): Promise<void> => {
    const client: B2bClientInterface = Vue.prototype.$container.b2bClient
    commit(mutationTypes.SET_CARD_DETAILS, await client.getCardDetails(cardId))
  },
  resetCurrentPageNumber: ({ commit }) => {
    commit(mutationTypes.SET_COMPANY_CARDS_CURRENT_PAGE_NUMBER, {number: DEFAULT_CURRENT_PAGE_NUMBER})
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/card/actions.js